import { useEffect, useState } from 'react'
import { Message } from '@arco-design/web-react'
import { getEnabledModelsApi } from '@/api/channels'
import type { OptionsAPI } from '../useOptions'
import VisualModelPricingEditor from './VisualModelPricingEditor'

export default function UnsetModelsPricingEditor({ options }: { options: OptionsAPI }) {
  const [enabledModels, setEnabledModels] = useState<string[]>([])
  const [loadError, setLoadError] = useState('')

  useEffect(() => {
    getEnabledModelsApi()
      .then((data) => {
        setEnabledModels(data ?? [])
        setLoadError('')
      })
      .catch((err) => {
        const message = err instanceof Error ? err.message : '获取启用模型失败'
        setLoadError(message)
        Message.error(message)
      })
  }, [])

  return (
    <div className="space-y-3">
      <div className="settings-info-strip">
        此页面仅列出启用渠道已声明但缺少基础定价（固定价或输入倍率）的模型。配置完成后会自动从列表中移出。
      </div>
      {loadError ? (
        <div className="settings-error-strip" role="alert">
          无法加载启用模型列表：{loadError}。请检查接口 /api/channel/enabled_models 或当前账号权限。
        </div>
      ) : null}
      <VisualModelPricingEditor
        options={options}
        candidateModelNames={enabledModels}
        filterMode="unset"
        allowAddModel={false}
        allowDeleteModel={false}
        showConflictFilter={false}
        listDescription="勾选多个模型后，可使用「批量应用当前模型价格」套用当前选中模型的定价配置。"
        emptyTitle="所有启用模型均已配置基础价格。"
        emptyDescription="所有启用模型均已配置基础价格。"
      />
    </div>
  )
}
